import React from 'react'
import { LoungeJoinScreen } from '@/screens/lounges/LoungeJoinScreen'

export default function LoungeJoinRoute() {
  return <LoungeJoinScreen />
}
